import { Col, Row, Slider } from 'antd';
import { SliderMarks } from 'antd/lib/slider';
import { noop } from 'lodash';
import React from 'react';
import InputCurrency from './InputCurrency';
import InputRate from './InputRate';

export type SliderWithInputAndPercentageProps = {
  disabled?: boolean;
  max: number;

  /**
   * @default 0
   */
  min?: number;

  contextmin?: number;
  contextmax?: number;

  onChange?: (value: number | '') => void;

  /**
   * @default 1
   */
  step?: number;

  /**
   * @default ''
   */
  value?: number;
  defaultValue?: number | '';
  basis: number;
  precisionAmount: number;
  precisionCoef: number;
  currcode: string;
  classNameSlider?: string;
  widthInput?: number;
  hideSlider?: boolean;
};

const SliderWithInputAndPercentage = ({
  max,
  min = 0,
  contextmin,
  contextmax,
  onChange = noop,
  step,
  value = 0,
  defaultValue = '',
  basis = '' as any,
  precisionAmount = 2,
  precisionCoef = 2,
  disabled,
  currcode,
  classNameSlider,
  widthInput = 4,
  hideSlider
}: SliderWithInputAndPercentageProps) => {
  const lbasis: number = basis === 0 ? 1 : basis;

  const handleChange = (newValue: any) => {
    onChange(typeof newValue === 'number' ? newValue : '');
  };

  const handleChangePercentage = (newPercentage: any = 0) => {
    handleChange((newPercentage / 100) * lbasis);
  };
  const percentage = (Number(value) / lbasis) * 100;
  const marks: SliderMarks = {
    [min]: {
      label: (
        <strong style={{ marginLeft: 15}} className='min'>
          {!isNaN(min) && min !== undefined
            ? Number(min).toFixed(precisionAmount)
            : 0}
        </strong>
      ),
    },
    [contextmin ?? min]: {
      style: {
        color: 'red',
        marginLeft:'-12px'
      },
      label: (
        <strong className='contextmin'>
          {contextmin !== undefined
            ? Number(String(contextmin ?? min)).toFixed(precisionAmount)
            : 0}
        </strong>
      ),
    },
    [contextmax ?? max]: {
      style: {
        color: 'red',
        marginTop:20

      },
      label: (
        <strong className='contextmax'>
          {contextmax !== undefined &&
            Number(String(contextmax ?? max)).toFixed(precisionAmount)}
        </strong>
      ),
    },
    [max]: {
      label: (
        <strong style={{ marginRight: 0}} className='max'>
          {!isNaN(max) && Number(String(max)).toFixed(precisionAmount)}
        </strong>
      ),
    },
  };

  return (
    <Row gutter={[8, 8]}>
      <Col span={5}>
        <InputCurrency
          disabled={disabled}
          min={(min * lbasis) / 100}
          max={(max * lbasis) / 100}
          style={{ width: '100%' }}
          step={step}
          precision={precisionAmount}
          defaultValue={defaultValue as number}
          value={!isNaN(value) ? value : 0}
          onChange={handleChange}
          currcode={currcode}
        />
      </Col>
      <Col span={5}>
        <InputRate
          disabled={disabled}
          min={min}
          max={max}
          style={{ width: '100%' }}
          step={step}
          value={percentage}
          precision={precisionCoef}
          onChange={handleChangePercentage}
        />
      </Col>
      {!hideSlider &&
        <Col span={14}>
          <Slider
            disabled={disabled}
            min={min}
            max={max}
            step={step}
            onChange={handleChangePercentage}
            style={{
              marginTop: 4,
              marginBottom: 16,
              position: 'relative',
              zIndex: 2,
              marginLeft: `calc(${widthInput}% + 10px)`,
            }}
            value={percentage}
            marks={marks}
            className={classNameSlider}
          />
        </Col>
      }
    </Row>
  );
};

export default SliderWithInputAndPercentage;
